module.exports = __webpack_public_path__ + "assets/img/joe_newell.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/joe_newell.jpg
// module id = 1944
// module chunks = 0